import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0 d-flex flex-stack w-100" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-semibold fs-6 text-primary m-0 umt-subhead" }, "Thông tin phiếu tiếp nhận hồ sơ", -1)
const _hoisted_5 = {
  key: 0,
  class: "badge badge-light-danger"
}
const _hoisted_6 = { class: "modal-body py-4 px-lg-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Hồ sơ bao gồm:", -1)
const _hoisted_8 = { class: "d-flex flex-colum mb-4" }
const _hoisted_9 = { class: "d-flex align-items-start gap-2" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { for: "paper0" }
const _hoisted_12 = { class: "d-flex flex-colum mb-4" }
const _hoisted_13 = { class: "d-flex align-items-start gap-2" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { for: "paper1" }
const _hoisted_16 = { class: "d-flex flex-colum mb-4" }
const _hoisted_17 = { class: "d-flex align-items-start gap-2" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { for: "paper2" }
const _hoisted_20 = { class: "d-flex flex-colum mb-4" }
const _hoisted_21 = { class: "d-flex align-items-start gap-2" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { for: "paper3" }
const _hoisted_24 = { class: "d-flex flex-colum mb-4" }
const _hoisted_25 = { class: "d-flex align-items-start gap-2" }
const _hoisted_26 = ["value"]
const _hoisted_27 = { for: "paper4" }
const _hoisted_28 = { class: "d-flex flex-colum mb-4" }
const _hoisted_29 = { class: "d-flex align-items-start gap-2" }
const _hoisted_30 = ["value"]
const _hoisted_31 = { for: "paper5" }
const _hoisted_32 = { class: "d-flex flex-colum mb-2" }
const _hoisted_33 = { class: "d-flex align-items-start gap-2" }
const _hoisted_34 = ["value"]
const _hoisted_35 = { for: "paper9" }
const _hoisted_36 = { class: "d-flex flex-colum mb-2" }
const _hoisted_37 = { class: "d-flex align-items-start gap-2" }
const _hoisted_38 = ["value"]
const _hoisted_39 = { for: "paper6" }
const _hoisted_40 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_41 = { class: "d-flex gap-2" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", null, "Chứng chỉ", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", null, "Điểm", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", null, "Ngày thi", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", null, "Thời hạn", -1)
const _hoisted_46 = { class: "d-flex flex-colum mb-2" }
const _hoisted_47 = { class: "d-flex align-items-start gap-2" }
const _hoisted_48 = ["value"]
const _hoisted_49 = { for: "paper8" }
const _hoisted_50 = { class: "d-flex flex-colum mb-2" }
const _hoisted_51 = { class: "d-flex align-items-start gap-2" }
const _hoisted_52 = ["value"]
const _hoisted_53 = { for: "paper7" }
const _hoisted_54 = { class: "d-flex flex-colum mb-2" }
const _hoisted_55 = { class: "d-flex align-items-start gap-2" }
const _hoisted_56 = ["value"]
const _hoisted_57 = { for: "paper10" }
const _hoisted_58 = { class: "d-flex flex-colum mb-2" }
const _hoisted_59 = { class: "d-flex align-items-start gap-2" }
const _hoisted_60 = ["value"]
const _hoisted_61 = { for: "paper11" }
const _hoisted_62 = { class: "d-flex gap-5 mt-6 mb-3" }
const _hoisted_63 = { class: "fv-row" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Hồ sơ cần nộp bổ sung:", -1)
const _hoisted_65 = { class: "d-flex flex-colum mb-2" }
const _hoisted_66 = { class: "d-flex align-items-start gap-2" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", { for: "paper9" }, "Hồ sơ bổ sung", -1)
const _hoisted_68 = {
  key: 2,
  class: "row g-0"
}
const _hoisted_69 = { class: "col-8" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("b", null, "Stt", -1)
const _hoisted_71 = { class: "col-4" }
const _hoisted_72 = { key: 3 }
const _hoisted_73 = { class: "col-8" }
const _hoisted_74 = { class: "col-4" }
const _hoisted_75 = { class: "w-100 text-center mt-5" }
const _hoisted_76 = {
  key: 0,
  class: "notice bg-light-warning rounded border-warning border border-dashed d-flex align-items-center p-4 mb-5 text-start"
}
const _hoisted_77 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle fs-2x text-warning me-4" }, null, -1)
const _hoisted_78 = { class: "fs-7" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-gray-800 mb-1" }, "Chưa thể lưu và in phiếu tiếp nhận", -1)
const _hoisted_80 = {
  key: 0,
  class: "text-gray-700"
}
const _hoisted_81 = /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold" }, "\"Chưa hoàn tất\"", -1)
const _hoisted_82 = {
  key: 1,
  class: "text-gray-700"
}
const _hoisted_83 = {
  key: 1,
  class: "notice bg-light-primary rounded border-primary border border-dashed d-flex align-items-center p-4 mb-5 text-start"
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle fs-2x text-primary me-4" }, null, -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "fs-7 text-gray-700" }, [
  /*#__PURE__*/_createTextVNode(" Hồ sơ đang "),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold" }, "\"Chờ xác thực\""),
  /*#__PURE__*/_createTextVNode(" (chưa xác nhận hoàn tất nhập học) — vẫn lưu và in được phiếu tiếp nhận. Lần in này sẽ được ghi vào "),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold" }, "lịch sử hồ sơ"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_86 = [
  _hoisted_84,
  _hoisted_85
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.isCancelled)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Phiếu đã hủy — chỉ xem"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_el_form, {
      model: _ctx.formData,
      ref: "formRef",
      rules: _ctx.rules,
      class: _normalizeClass(_ctx.isCancelled ? 'opacity-75 pe-none' : '')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                class: "mt-1",
                id: "paper0",
                type: "checkbox",
                value: _ctx.paperOption[0],
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.groupPaper) = $event))
              }, null, 8, _hoisted_10), [
                [_vModelCheckbox, _ctx.formData.groupPaper]
              ]),
              _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.paperOption[0]), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                class: "mt-1",
                id: "paper1",
                type: "checkbox",
                value: _ctx.paperOption[1],
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.groupPaper) = $event))
              }, null, 8, _hoisted_14), [
                [_vModelCheckbox, _ctx.formData.groupPaper]
              ]),
              _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.paperOption[1]), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                class: "mt-1",
                id: "paper2",
                type: "checkbox",
                value: _ctx.paperOption[2],
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.groupPaper) = $event))
              }, null, 8, _hoisted_18), [
                [_vModelCheckbox, _ctx.formData.groupPaper]
              ]),
              _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.paperOption[2]), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _withDirectives(_createElementVNode("input", {
                class: "mt-1",
                id: "paper3",
                type: "checkbox",
                value: _ctx.paperOption[3],
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.groupPaper) = $event))
              }, null, 8, _hoisted_22), [
                [_vModelCheckbox, _ctx.formData.groupPaper]
              ]),
              _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.paperOption[3]), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _withDirectives(_createElementVNode("input", {
                class: "mt-1",
                id: "paper4",
                type: "checkbox",
                value: _ctx.paperOption[4],
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.groupPaper) = $event))
              }, null, 8, _hoisted_26), [
                [_vModelCheckbox, _ctx.formData.groupPaper]
              ]),
              _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.paperOption[4]), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _withDirectives(_createElementVNode("input", {
                class: "mt-1",
                id: "paper5",
                type: "checkbox",
                value: _ctx.paperOption[5],
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.groupPaper) = $event))
              }, null, 8, _hoisted_30), [
                [_vModelCheckbox, _ctx.formData.groupPaper]
              ]),
              _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.paperOption[5]), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _withDirectives(_createElementVNode("input", {
                class: "mt-1",
                id: "paper9",
                type: "checkbox",
                value: _ctx.paperOption[9],
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.groupPaper) = $event))
              }, null, 8, _hoisted_34), [
                [_vModelCheckbox, _ctx.formData.groupPaper]
              ]),
              _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.paperOption[9]), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _withDirectives(_createElementVNode("input", {
                class: "mt-1",
                id: "paper6",
                type: "checkbox",
                value: _ctx.paperOption[6],
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.groupPaper) = $event))
              }, null, 8, _hoisted_38), [
                [_vModelCheckbox, _ctx.formData.groupPaper]
              ]),
              _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.paperOption[6]), 1)
            ])
          ]),
          (_ctx.formData.groupPaper.includes(_ctx.paperOption[6]))
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createVNode(_component_el_form, { "label-position": "top" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", null, [
                        _hoisted_42,
                        _createVNode(_component_el_select, {
                          class: "el-select w-100",
                          modelValue: _ctx.formData.englishName,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.englishName) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionCret, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item,
                                label: item,
                                value: item
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_43,
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.englishCode,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.englishCode) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_44,
                        _createVNode(_component_el_date_picker, {
                          class: "el-date-picker w-100",
                          type: "date",
                          format: "DD/MM/YYYY",
                          modelValue: _ctx.formData.englishDate,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.englishDate) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_45,
                        _createVNode(_component_el_date_picker, {
                          class: "el-date-picker w-100",
                          type: "date",
                          format: "DD/MM/YYYY",
                          modelValue: _ctx.formData.englishExpire,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.englishExpire) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _withDirectives(_createElementVNode("input", {
                class: "mt-1",
                id: "paper8",
                type: "checkbox",
                value: _ctx.paperOption[8],
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.groupPaper) = $event))
              }, null, 8, _hoisted_48), [
                [_vModelCheckbox, _ctx.formData.groupPaper]
              ]),
              _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.paperOption[8]), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _withDirectives(_createElementVNode("input", {
                class: "mt-1",
                id: "paper7",
                type: "checkbox",
                value: _ctx.paperOption[7],
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.groupPaper) = $event))
              }, null, 8, _hoisted_52), [
                [_vModelCheckbox, _ctx.formData.groupPaper]
              ]),
              _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.paperOption[7]), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _withDirectives(_createElementVNode("input", {
                class: "mt-1",
                id: "paper10",
                type: "checkbox",
                value: _ctx.paperOption[10],
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.groupPaper) = $event))
              }, null, 8, _hoisted_56), [
                [_vModelCheckbox, _ctx.formData.groupPaper]
              ]),
              _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.paperOption[10]), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _withDirectives(_createElementVNode("input", {
                class: "mt-1",
                id: "paper11",
                type: "checkbox",
                value: _ctx.paperOption[11],
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.groupPaper) = $event))
              }, null, 8, _hoisted_60), [
                [_vModelCheckbox, _ctx.formData.groupPaper]
              ]),
              _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.paperOption[11]), 1)
            ])
          ]),
          (_ctx.formData.groupPaper.includes('Hồ sơ khác:'))
            ? (_openBlock(), _createBlock(_component_el_input, {
                key: 1,
                class: "mb-4",
                modelValue: _ctx.formData.paperOrther,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.paperOrther) = $event))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _hoisted_64,
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _withDirectives(_createElementVNode("input", {
                    class: "mt-1",
                    id: "paper9",
                    type: "checkbox",
                    value: "paperMore",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.isPager) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.isPager]
                  ]),
                  _hoisted_67
                ])
              ])
            ])
          ]),
          (_ctx.isPager.includes('paperMore'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.header1,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.header1) = $event)),
                    class: "input-custom input-custom-header",
                    readonly: ""
                  }, {
                    prepend: _withCtx(() => [
                      _hoisted_70
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.header2,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.header2) = $event)),
                    class: "input-custom input-custom-header",
                    readonly: ""
                  }, null, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isPager.includes('paperMore'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.pagerComplement, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "row g-0",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_73, [
                      _createVNode(_component_el_input, {
                        class: "w-100 input-custom",
                        modelValue: item.value,
                        "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                        onChange: _ctx.checkData
                      }, {
                        prepend: _withCtx(() => [
                          _createTextVNode(_toDisplayString(index+1), 1)
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_74, [
                      _createVNode(_component_el_date_picker, {
                        class: "w-100 input-custom",
                        modelValue: item.date,
                        "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                        type: "date",
                        onChange: _ctx.checkData
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_75, [
            ((!_ctx.canPrintTicket && !_ctx.isCancelled) || !_ctx.dataUser.email)
              ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                  _hoisted_77,
                  _createElementVNode("div", _hoisted_78, [
                    _hoisted_79,
                    (!_ctx.canPrintTicket && !_ctx.isCancelled)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                          _createTextVNode(" • Ứng viên chưa hoàn tất khai hồ sơ nhập học (hiện đang "),
                          _hoisted_81,
                          _createTextVNode("). ")
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.dataUser.email)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_82, " • Chưa có email sinh viên — vui lòng tạo email trước. "))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.canPrintTicket && _ctx.isPendingConfirm && _ctx.dataUser.email)
              ? (_openBlock(), _createElementBlock("div", _hoisted_83, _hoisted_86))
              : _createCommentVNode("", true),
            (_ctx.formData.groupPaper.length || _ctx.isPager.includes('paperMore'))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 2,
                  disabled: !_ctx.formData.groupPaper?.includes(_ctx.paperOption[0]) || !_ctx.canPrintTicket,
                  type: "primary",
                  class: _normalizeClass(["m-auto", (_ctx.expiredPromotion && !_ctx.dataReceipt) || !_ctx.dataUser.email || !_ctx.canPrintTicket?'disabled':'']),
                  onClick: _ctx.printAction
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Lưu và In phiếu ")
                  ]),
                  _: 1
                }, 8, ["disabled", "class", "onClick"]))
              : _createCommentVNode("", true)
          ])), [
            [_directive_permission, [_ctx.Permission.APPLICANT_PRINT, _ctx.Permission.APPLICANT]]
          ])
        ])
      ]),
      _: 1
    }, 8, ["model", "rules", "class"])
  ]))
}